<script setup lang="ts">
import { useTagsViewStore } from '@/store/modules/tagsView';
import { computed } from 'vue';

const tagsViewStore = useTagsViewStore();

// 始终需要缓存的布局组件
const ALWAYS_CACHED_LAYOUTS = ['database-detail'];

const getCaches = computed((): string[] => {
  // 合并标签页缓存和固定缓存的布局组件
  const tagCaches = tagsViewStore.getCachedViews;
  return [...new Set([...tagCaches, ...ALWAYS_CACHED_LAYOUTS])];
});
</script>

<template>
  <section
    :class="[
      'flex-1 min-h-0',
    ]"
  >
    <router-view>
      <template #default="{ Component, route }">
        <keep-alive :include="getCaches">
          <component :is="Component" :key="route.name" />
        </keep-alive>
      </template>
    </router-view>
  </section>
</template>
